module.exports = __webpack_public_path__ + "static/img/card-3.33c8522.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-3.png
// module id = Woa7
// module chunks = 0